package io.horion.cv.models

enum class ApplyJobStatus{
    PENDING,     // En attente
    ACCEPTED,    // Acceptée
    REJECTED     // Rejetée
}